import { MessageCircle, Instagram, Globe } from "lucide-react";
import { Reveal } from "@/components/shared";
import { waLink, WHATSAPP_DISPLAY, INSTAGRAM_HANDLE, INSTAGRAM_URL, SITE_URL } from "@/lib/site";

export default function Contact() {
  return (
    <section id="contato" className="grain relative scroll-mt-20 overflow-hidden py-28 lg:py-36">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[800px] -translate-x-1/2 rounded-full bg-gold/[0.07] blur-[120px]" />
      <div className="relative mx-auto max-w-5xl px-5 text-center lg:px-8">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold">Contato</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-wide text-white sm:text-5xl lg:text-6xl">
            Vamos proteger <span className="text-gold-grad">o seu patrimônio?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-6 max-w-2xl leading-relaxed text-slate-400">
            Fale com a Realiza Engenharia e descubra como podemos ajudar seu condomínio a tomar
            decisões mais seguras, reduzir riscos e investir melhor.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="mx-auto mt-10 max-w-3xl font-serif text-xl italic leading-snug text-slate-300 sm:text-2xl">
            A Realiza não vende reformas. A Realiza protege as decisões do síndico.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-12 grid gap-4 sm:grid-cols-3">
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-card-whatsapp"
              className="group border border-white/[0.08] bg-white/[0.02] p-6 transition-all duration-300 hover:border-gold/50 hover:bg-white/[0.04]"
            >
              <MessageCircle className="mx-auto h-6 w-6 text-gold" />
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500">WhatsApp</p>
              <p className="mt-1 font-display text-lg font-bold tracking-wide text-white group-hover:text-gold">{WHATSAPP_DISPLAY}</p>
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-card-instagram"
              className="group border border-white/[0.08] bg-white/[0.02] p-6 transition-all duration-300 hover:border-gold/50 hover:bg-white/[0.04]"
            >
              <Instagram className="mx-auto h-6 w-6 text-gold" />
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500">Instagram</p>
              <p className="mt-1 font-display text-lg font-bold tracking-wide text-white group-hover:text-gold">{INSTAGRAM_HANDLE}</p>
            </a>
            <a
              href={SITE_URL}
              data-testid="contact-card-site"
              className="group border border-white/[0.08] bg-white/[0.02] p-6 transition-all duration-300 hover:border-gold/50 hover:bg-white/[0.04]"
            >
              <Globe className="mx-auto h-6 w-6 text-gold" />
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-slate-500">Site</p>
              <p className="mt-1 font-display text-lg font-bold tracking-wide text-white group-hover:text-gold">realizaengenhariapredial.com</p>
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.36}>
          <div className="mt-12">
            <p className="font-display text-2xl font-bold uppercase tracking-wide text-white">
              Pronto para tomar decisões mais seguras?
            </p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-final-cta"
              className="mt-6 inline-flex items-center gap-3 rounded-full bg-gold px-10 py-4 font-display text-base font-bold tracking-[0.14em] text-navy-950 transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_40px_rgba(212,175,55,0.45)]"
            >
              <MessageCircle className="h-5 w-5" /> FALAR COM A REALIZA ENGENHARIA
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
